var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTaniumNotStarted = function SvgTaniumNotStarted(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 89,
    height: 98,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#C3CBD4",
    opacity: 0.88
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.063 23.055v.294l.257.143L88.5 62.576v10.143c0 .487-.27.946-.722 1.198l-15.567 8.67V73.75l-.257-.143L.5 33.815v-8.48c0-.488.27-.947.722-1.199l16.841-9.379z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.5 70.423V48.165l62.494 37.513-18.441 10.97a1.38 1.38 0 0 1-1.417 0L1.22 71.715a1.5 1.5 0 0 1-.72-1.292ZM45.376.682a1.44 1.44 0 0 1 1.4 0L87.812 23.65l.244-.436-.244.436c.43.242.688.682.688 1.15v18.843L28.833 9.941z",
    opacity: 0.55
  }))));
};
export default SvgTaniumNotStarted;